export const AUTO_ACCEPT_INTERNET_BIDS_TOAST_DURATION_MS = 2000;

export const AUTO_ACCEPT_INTERNET_BIDS_DELAY_MS = 300;
